// TODO: Took this from bf_shopping_ui; might wanna do the @todo below
// and move it to react-components...

import { useContext, useEffect, useRef } from 'react';
import {
  isOn,
  getExperimentVariant,
} from '@buzzfeed/react-components/lib/utils/abeagle';
import { ABeagleContext } from '../contexts';

function getControlledPromise() {
  let resolve;
  const promise = new Promise(r => (resolve = r));
  return [promise, resolve];
}

/**
 * Async version of the ABeagle client functions
 * so that the consuming component can use them right away
 * instead of having to check whether experiments are loaded on every render
 * (since the functions provided by `react-components` are synchronous
 * and simply return null when experiments are not loaded yet)
 * @todo Move to `react-components`?
 */
export const useABeagleAsync = () => {
  const { experiments } = useContext(ABeagleContext);
  const requested = useRef();

  const experimentsRef = useRef({});
  if (!requested.current) {
    [
      experimentsRef.current.loaded,
      experimentsRef.current.resolve,
    ] = getControlledPromise();
  }
  requested.current = true;

  const abeagle = useRef({
    experiments: experimentsRef.current.loaded,
    isOn: function() {
      return experimentsRef.current.loaded.then(abtests =>
        isOn(abtests, ...arguments)
      );
    },
    getExperimentVariant: function() {
      return experimentsRef.current.loaded.then(abtests =>
        getExperimentVariant(abtests, ...arguments)
      );
    },
  });

  useEffect(() => {
    if (experiments && experiments.loaded && !experiments.stale) {
      experimentsRef.current.resolve(experiments);
    }
  }, [experiments]);

  return abeagle.current;
};

export default useABeagleAsync;
